/**
 * Setup the logic for showing and displaying the card bubbles.
 */
// eslint-disable-next-line consistent-return
function setupCardBubbles() {
	const cardBubbles = document.querySelectorAll( '[data-card-bubble]' );

	if ( ! cardBubbles ) {
		return false;
	}

	cardBubbles.forEach( cardBubble => {

		cardBubble.setAttribute( 'aria-expanded', false );
		const cardBack = cardBubble.querySelector( '.card-back' );
		cardBack.setAttribute( 'aria-hidden', true );

		cardBubble.addEventListener( 'click', () => {

			cardBubble.classList.toggle( 'flipped' );

			if ( cardBubble.getAttribute( 'aria-expanded' ) === 'false' ) {
				cardBubble.setAttribute( 'aria-expanded', true );
				cardBack.setAttribute( 'aria-hidden', false );
			} else {
				cardBubble.setAttribute( 'aria-expanded', false );
				cardBack.setAttribute( 'aria-hidden', true );
			}

		} );

	} );
}
document.addEventListener( 'DOMContentLoaded', () => {
	setupCardBubbles();
} );
